// This file is AUTOGENERATED, do not edit it manually!!!

export const koPeopleTemplates = {
    nomatch_text: 'Sorry, nothing was found',
    roles: 'Roles',
    teams: 'Teams',
    users: 'Users',
};
